import { j as json } from "../../../../../../chunks/index2.js";
import { S as SessionCollection } from "../../../../../../chunks/firebase.js";
const GET = async ({ cookies }) => {
  const sessionId = cookies.get("session_id");
  if (sessionId) {
    cookies.delete("session_id", { path: "/", httpOnly: true, secure: true });
    await SessionCollection().doc(sessionId).delete();
  }
  return json({
    success: true
  });
};
export {
  GET
};
